import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7l10 10","key":"svg-0"}],["path",{"d":"M16 7l-9 0l0 9","key":"svg-1"}]]

const IconArrowUpLeft = createReactComponent('outline', 'arrow-up-left', 'ArrowUpLeft', __iconNode);

export default IconArrowUpLeft;